<template>
  <div class="w-full">
    <hr class="my-3" />
    <!-- header section profile pic and time ago -->
    <div class="flex items-center mt-3">
      <a :href="`https://twitter.com/${acctUsername}`" target="_blank">
        <div class="avatar">
          <div class="w-16 rounded-full">
            <img :src="profilePic" />
          </div>
        </div>
      </a>
      <div class="ml-8 mt-2">
        <a :href="`https://twitter.com/${acctUsername}`" target="_blank">
          <h5 class="font-semibold text-xl">{{ userName }}</h5>
        </a>
        <p class="-mt-2 text-gray-600">
          <a :href="`https://twitter.com/${acctUsername}`" target="_blank">
            @{{ acctUsername }}
          </a>
        </p>
      </div>
      <!-- <div class="ml-auto text-gray-600 tracking-wider">
        <a
          :href="`https://twitter.com/messages/${userDetails.providerId}-${memberProviderId}`"
          target="_blank"
        >
          {{ createdAt | moment }}
        </a>
      </div> -->
    </div>
    <!-- show all message here start -->
    <section
    v-if="dmInfo.length"
      class="py-5 h-64 overflow-auto w-full"
      :id="memberProviderId || 'chat'"
      v-chat-scroll="{always: false}"
    >
      <div
        v-for="(data, index) in dmInfo"
        :key="index"
        :class="[
          ' px-4 py-3 w-2/3 rounded-tl-3xl rounded-tr-3xl hover:opacity-75',
          userDetails && dmInfo && userDetails.providerId !== data.sender_id
            ? 'mr-auto'
            : 'ml-auto',
        ]"
      >
        <message-container
          :dmInfo="data"
          :acctUsername="acctUsername"
          :providerId="providerId"
          :userName="userName"
        />
      </div>
    </section>
    <section v-if="dmInfo.length === 0" class="py-5 h-64 flex items-center justify-center">
      <h3 class=" text-gray-600 text-xl">
        Past DM information not available
      </h3>
    </section>

    <!-- show all message here end -->
    <hr class="my-3" />
    <!-- <div v-if="!isAbove" class="flex justify-between">
      <section>
        <button
          v-if="myDmCounts !== currentDm + 1"
          type="button"
          @click="handleNextCallback"
          class="btn btn-outline ml-5"
        >
          Older
        </button>
        <button
          v-if="!isFirst"
          type="button"
          @click="handlePrevCallback"
          class="btn btn-outline ml-5"
        >
          Newer
        </button>
      </section>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import MessageContainer from './MessageContainer.vue';
// import spinner from '@/components/spinner.vue';

export default {
  components: { MessageContainer },
  name: 'DmRenderLeft',
  store,
  props: [
    'dmInfo',
    'acctUsername',
    'providerId',
    'profilePic',
    'userName',
    'handleNextCallback',
    'handlePrevCallback',
    'isFirst',
    'currentDm',
  ],
  data() {
    return {
      twitterText: '',
      urlData: [],
      memberProviderId: this.dmInfo[0]?.conversation_id.split('_')[1],
    };
  },
  computed: {
    createdAt() {
      return new Date(Number(this.dmInfo[0]?.dm_created_timestamp));
    },
    userDetails() {
      return this.$store.state.userDetails;
    },
    myDmCounts: {
      get() {
        const { dmCounts } = this.$store.state.connect;
        const myCount = dmCounts.find(
          (data) => data.conversation_id === this.dmInfo[0]?.conversation_id,
        );
        return myCount?.totalCount;
      },
      set(newValue) {
        return newValue;
      },
    },
  },
  mounted() {
    if (!this.userDetails?.providerId) {
      this.$store.dispatch('getMyDetails', {});
    }
    this.customeScrollToBottom();
  },
  watch: {
    dmInfo(newInfo, oldInfo) {
      if (newInfo !== oldInfo) {
        this.urlData = [];
        this.memberProviderId = this.dmInfo[0]?.conversation_id.split('_')[1];
      }
    },
    // userDetails(newVal) {
    //   this.isAbove = newVal?.configureInfo?.connectTabBtnShowAbove;
    // },
  },
  methods: {
    customeScrollToBottom() {
      const chatScreen = document.getElementById(this.memberProviderId);
      if (chatScreen) {
        console.log(chatScreen);
        chatScreen.scrollTo(0, chatScreen.scrollHeight);
        console.log(chatScreen.scrollHeight, this.memberProviderId);
        chatScreen.addEventListener('scroll', () => {
          if (
            chatScreen.scrollTop === 0
          ) {
            this.handleNextCallback();
            chatScreen.scrollTop = chatScreen.clientHeight + 50;
          }
        });
      }
    },
  },
  filters: {
    moment: (date) => moment(date).fromNow(),
  },
};
</script>
